import Pagination from 'components/Table/Pagination';
import PaymentPageList from '../models/paymentPageEntity';
import PaymentTrxnList from '../models/paymentTransaction';

import { GET_ACTIVE_REPORT_ERROR, GET_ACTIVE_REPORT_SUCCESS } from '../../Transactions/redux/transactions.constants';
import {
    HIDE_PAYMENT_PAGE_LOADER,
    SHOW_PAYMENT_PAGE_LOADER,
    GET_PAYMENT_PAGE_DETAILS_ERROR,
    GET_PAYMENT_PAGE_DETAILS_SUCCESS,
    UPDATE_PAYMENT_PAGE_DETAILS_SUCCESS,
    UPDATE_PAYMENT_PAGE_DETAILS_ERROR,
    FETCH_PAYMENT_PAGE_SUCCESS,
    FETCH_PAYMENT_PAGE_ERROR,
    FETCH_TRANSACTION_PAYMENT_ERROR,
    FETCH_TRANSACTION_PAYMENT_SUCCESS,
    RE_SHARE_PAY_PAGE_SUCCESS,
    RE_SHARE_PAY_PAGE_ERROR,
    VIEW_PAY_LINK_SUCCESS,
    VIEW_PAY_LINK_ERROR,
    GENERATE_REPORT_ERROR_PAYMENT_PAGE,
    GENERATE_REPORT_SUCCESS_PAYMENT_PAGE,
} from './paymentPage.constants';

export const initialState = {
    paymentPageData: [],
    pagination: {},
    error: {},
    paginationTxn: {},
    isLoading: false,
    tableData: [],
    tableDataTxn: [],
    viewPay: {},
    createPay: {
        isSuccess: false,
    },
    updatePayLink: {
        isSuccess: false,
    },
    sharePay: {
        isSuccess: false,
    },
    reSharePay: {
        isSuccess: false,
    },
    templateDetails: {
        isSuccess: false,
    },
    generatedFile: {
        isSuccess: false,
        error: {},
    },
    activeReports: {
        reports: null,
    },
    paymentPageEditData: null,
    formLinkData: {},
};

const getActiveReports = reports => {
    const reportsAll = {};
    if (reports.reportsList.length) {
        reportsAll.generating = reports.reportsList.filter(
            item => item.requestStatus !== 'COMPLETED'
        );
        reportsAll.complete = reports.reportsList.filter(
            item => item.requestStatus === 'COMPLETED'
        );
    }
    return reportsAll;
};


export const paymentPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PAYMENT_PAGE_SUCCESS: {
            const payPageData = new PaymentPageList(action.payload);
            return {
                ...state,
                ...payPageData,
                paymentPageEditData:{},
                error: {},
            };
        }
        case FETCH_PAYMENT_PAGE_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case FETCH_TRANSACTION_PAYMENT_SUCCESS: {
            const txnPayData = new PaymentTrxnList(action.payload);
            return {
                ...state,
                ...txnPayData,
                error: {},
            };
        }
        case FETCH_TRANSACTION_PAYMENT_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case RE_SHARE_PAY_PAGE_SUCCESS: {
            return {
                ...state,
                paymentPageData: {},
                formLinkData: action.payload,
                error: {},
            };
        }
        case RE_SHARE_PAY_PAGE_ERROR: {
            return {
                ...state,
                reSharePay: { isSuccess: false, ...action.payload },
                error: {},
            };
        }
        case VIEW_PAY_LINK_SUCCESS: {
            return {
                ...state,
                viewPay: { ...action.payload },
                error: {},
            };
        }
        case GET_PAYMENT_PAGE_DETAILS_SUCCESS: {
            return {
                ...state,
                paymentPageEditData: action.payload,
                paymentPageData :{},
                error: {},
            };
        }
        case GET_PAYMENT_PAGE_DETAILS_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case UPDATE_PAYMENT_PAGE_DETAILS_SUCCESS:
            return {
                ...state,
                paymentPageData :action.payload,
                error: {},
            };
        case UPDATE_PAYMENT_PAGE_DETAILS_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case VIEW_PAY_LINK_ERROR: {
            return {
                ...state,
                viewPay: { ...action.payload },
                error: {},
            };
        }
        case GENERATE_REPORT_SUCCESS_PAYMENT_PAGE:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: true },
            };
        case GENERATE_REPORT_ERROR_PAYMENT_PAGE:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };

        case GET_ACTIVE_REPORT_SUCCESS:
            return {
                ...state,
                activeReports: { reports: getActiveReports(action.payload) },
            };
        case GET_ACTIVE_REPORT_ERROR:
            return {
                ...state,
                activeReports: { ...action.payload },
            };
        case SHOW_PAYMENT_PAGE_LOADER:
            return { ...state, isLoading: true };
        case HIDE_PAYMENT_PAGE_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
